import type { ReactNode } from 'react';

import { cn } from '@/utils/classname';

interface SidebarListItemProps {
  isSelected: boolean;
  onClick: () => void;
  children: ReactNode;
}

/**
 * Shared list-item used by the Memory and Chat panes' inner sidebars.
 * Handles selection styling and keyboard focus; renders whatever row
 * content its children provide.
 */
export function SidebarListItem({
  isSelected,
  onClick,
  children,
}: SidebarListItemProps) {
  return (
    <li>
      <button
        type="button"
        onClick={onClick}
        className={cn(
          'border-chariot-stroke hover:bg-chariot-background-secondary w-full border-b px-3 py-2 text-left text-xs transition-colors',
          isSelected && 'bg-chariot-background-secondary'
        )}
      >
        {children}
      </button>
    </li>
  );
}
